"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (amount) {
    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    });
    return formatter.format(amount);
});
